import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { TutorialStatus, useTutorialStore } from '@wwt/core/tutorial'

export const useRestartTutorial = () => {
	const navigate = useNavigate()

	const setTutorialStatus = useTutorialStore.use.setTutorialStatus()

	const handleSelect = useCallback(() => {
		navigate('/', { state: { isNpsAllow: false } })

		setTutorialStatus(TutorialStatus.RESET)
	}, [navigate, setTutorialStatus])

	return {
		handleSelect
	}
}
